import Heading from '~/core/ui/Heading';

function NewsletterSignup() {
  return (
    <div className={'flex flex-col space-y-4'}>
      <div>
        <Heading type={6} className="mt-2 mb-[1.6rem]">
          Subscribe to our Newsletter
        </Heading>

        <div className={'text-sm text-gray-500 dark:text-gray-400'}>
          AI, Tech & Faith Weekly Digest
        </div>
      </div>

      <div>
        <iframe
          src="https://embeds.beehiiv.com/ef7462b9-4523-4224-a09c-30946fb7f0b9?slim=true"
          data-test-id="beehiiv-embed"
          height="120"
          frameBorder="0"
          scrolling="no"
          style={{
            margin: '0',
            borderRadius: '0px !important',
            backgroundColor: 'transparent',
          }}
        ></iframe>
      </div>
    </div>
  );
}

export default NewsletterSignup;
